// extracted by mini-css-extract-plugin
export var body = "SubscribeModalForm-module--body--5d084";
export var bodyFooterButton = "SubscribeModalForm-module--body-footer-button--a5a79";
export var disclaimerText = "SubscribeModalForm-module--disclaimer-text--2ee13";
export var footer = "SubscribeModalForm-module--footer--02822";
export var header = "SubscribeModalForm-module--header--f621d";